import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ExecuteLayoutEventMethods } from "../../../General/commonFunctions";

const IframeComponent = (props) => {
  const history = useHistory();

  useEffect(() => {
    const handleMessage = async (event) => {
      if (typeof event.data === "string") {
        try {
          const decodedString = atob(event.data);
          const parsedJson = JSON.parse(decodedString);

          if (typeof parsedJson === "string" && parsedJson.startsWith("/")) {
            history.push(parsedJson);
          } else {
            await ExecuteLayoutEventMethods(parsedJson);
          }
        } catch (error) {
          console.error("Base64 decoding or JSON parsing failed:", error);
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [history]);

  return <iframe {...props} />;
};

export default IframeComponent;
